<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
          <path :fill="color" d="M285 5101 c-108 -39 -199 -121 -251 -226 l-29 -60 0 -2040 0 -2040
          32 -65 c18 -36 46 -81 62 -101 70 -84 101 -97 829 -340 l687 -230 105 3 c96 3
          112 6 173 36 121 60 208 171 236 300 6 29 11 109 11 177 l0 125 368 0 c295 0
          380 3 427 15 173 44 337 177 413 336 70 145 73 177 70 724 l-3 480 -25 45
          c-14 24 -45 58 -68 75 -40 27 -51 30 -122 30 -71 0 -82 -3 -122 -30 -23 -17
          -54 -51 -68 -75 l-25 -45 -5 -490 -5 -490 -23 -38 c-28 -44 -73 -80 -121 -96
          -23 -7 -143 -11 -362 -11 l-329 0 -2 1648 -3 1647 -22 55 c-45 110 -144 209
          -248 250 l-50 19 489 0 c339 1 500 -3 527 -10 47 -14 104 -60 127 -102 15 -28
          18 -77 22 -417 l5 -385 28 -47 c40 -69 102 -103 187 -103 71 1 108 15 154 61
          62 63 61 54 64 464 3 430 -2 479 -70 619 -76 159 -240 292 -413 336 -51 13
          -229 15 -1330 15 -1200 -1 -1273 -2 -1320 -19z"/>
          <path :fill="color" d="M3981 4046 c-51 -17 -94 -55 -124 -111 -21 -38 -22 -54 -25 -387 l-4
          -347 -462 -3 -463 -3 -41 -29 c-109 -75 -122 -247 -26 -338 62 -58 63 -58 548
          -58 l445 0 3 -343 3 -343 26 -49 c36 -72 92 -108 173 -113 117 -8 98 -22 584
          462 243 242 455 458 469 480 32 45 43 141 23 203 -10 30 -106 132 -464 491
          -256 257 -468 462 -489 473 -50 26 -122 32 -176 15z"/>
      </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#5a6b8e',
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/ExitIcon.vue